import { useTranslation } from 'react-i18next';
export function useIsGerman() {
    const { i18n } = useTranslation();
    const isGerman = i18n.language.startsWith('de');
    return isGerman;
}
